(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('openbaseWizardService', openbaseWizardService)
    .controller('OpenbaseWizardController', OpenbaseWizardController)
    .controller('OpenbaseWizardEntities', OpenbaseWizardEntities)
    .controller('OpenbaseWizardSiteCategories', OpenbaseWizardSiteCategories)
    .controller('OpenbaseWizardDepartment', OpenbaseWizardDepartment)
    .controller('OpenbaseWizardPartnerCategories', OpenbaseWizardPartnerCategories);


    function route($routeProvider) {
        $routeProvider.when('/configuration/wizard', {
            templateUrl: 'partials/openbase/wizard_view.html',
            controller: 'OpenbaseWizardController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }


    function openbaseWizardService($http, swif) {
        'ngInject';
        var service = {};
        /**
         * call import_data
         * @param  {string} contentType
         * @param  {array} fields      array of field id
         * @param  {array} data        array of array
         * @return {promise}
         */
        service.import_data = function (contentType, fields, data) {
            return swif.data.callKw(contentType, 'import_data', [
                fields, data
            ]);
        };
        service.pre_import_data = function (input, fields) {
            //transform object to array for import
            return swif.data.prepareImport(input, fields);
        };
        service.load_json = function (model, url) {
            $http.get(url).then(function (data) {
                model._vocab = data.data.data;
                if (!model.vocab) {
                    model.vocab = [];
                }
                if (!model.tags) {
                    model.tags = [];
                }
                _.forEach(model._vocab, function (data) {
                    if (!_.contains(model.tags, data._tag)) {
                        model.tags.push(data._tag);
                    }
                });
            });
        };
        return service;
    }


    function OpenbaseWizardController($scope, swif, swifOpenbaseCompanyService, swifOpenbaseBANService) {
        'ngInject';
        $scope.debug = false;
        $scope.modules = swif.module.modules;
        $scope.import_mode = {selected: 'json'};
        swifOpenbaseCompanyService.getCompany().then(function(company) {
            $scope.company = company;
        });

        // Get BAN connector infos if modules is installed
        if ($scope.modules.opengst_ban) {
            // Get last synchronization date
            swifOpenbaseBANService.getLastSynchronisationDate().then(function (datesCollection) {
                if (datesCollection.items.length) {
                    let lastTime = datesCollection.items[datesCollection.items.length - 1];
                    let dates = {
                        lastStart: lastTime.start_time && moment(lastTime.start_time).format('DD/MM/YYYY HH:mm'),
                        lastEnd: lastTime.end_time && moment(lastTime.end_time).format('DD/MM/YYYY HH:mm')
                    }
                    $scope.banLastSynchro = dates;
                    $scope.canSynchronizeBan = dates && dates.lastStart && moment().isAfter(dates.lastStart, 'day');
                    console.log($scope.banLastSynchro, $scope.canSynchronizeBan)
                } else {
                    $scope.banLastSynchro = undefined;
                    $scope.canSynchronizeBan = true;
                }
            })
            swifOpenbaseBANService.getBANConnector().then(function(connector) {
                $scope.banConnector = connector;
            });
        }


        const tinymceOptions = {
            height: 300,
            plugins: 'textcolor code',
            language : 'fr_FR',
            menubar: false,
            toolbar: 'formatselect | fontselect | fontsizeselect | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | forecolor | code | removeformat'
        };

        swif.resources.add(['tinymce']).then(function () {
            $scope.tinymceOptions = tinymceOptions;
        });

        $scope.nominatim = {};

        $scope.$watch('company.name', function (newV) {
            if (newV) {
                $scope.nominatim.query = newV;
            }
        });

        $scope.saveCompany = function () {
            swifOpenbaseCompanyService.saveCompany($scope.company);
        };

        $scope.saveBANConnector = function () {
            swifOpenbaseBANService.saveBANConnector($scope.banConnector);
        }

        let preValidateBAN = function () {
            $scope.canSynchronizeBan = false;

            // We launch a blind callKw without waiting the callback because
            // the response may take a long time to arrive
            swif.data.callKw('ban_connector', 'synchronize', [], {});

            return true;
        }

        $scope.synchronizeBAN = function () {
            // We dispatch manually the action to open the modal here because <swif-actions>
            // doesn't let us choose the color of the button... So sad :(
            var action = swif.action.getActionById('ban_connector', 'workflow', 'synchronize', {});
            let options = {
                preModal: function () {},
                preValidate: preValidateBAN,
                callback: function () {}
            }
            swif.action.dispatch('ban_connector', action, {}, options);
        }
    }

    function OpenbaseWizardEntities($scope, swif) {
        swif.collections.createOrUpdate(
            'entities',
            'entity',
            {}
        ).then(function (collection) {
            $scope.entities = collection;
        });

        $scope.callback = function (error, data) {
            $scope.entities.fasterCallback(data);
        };
    }

    function OpenbaseWizardSiteCategories($scope, swif, $http, $q, openbase) {
        'ngInject';
        var wizard = openbase.wizard;
        $scope.loading = {import: {}};
        $scope.contentType = 'site_category';
        $scope.heads = 'Nom,Description';
        $scope.items = {};
        $scope.fields = ['name', 'description'];
        wizard.load_json($scope.items, 'json/wizard_site_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var fields = ['name', 'description', 'code'];
            var data = wizard.pre_import_data($scope.items.selected, fields);
            wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.addInfo('data imported successfully');
                swif.message.loading($scope.loading.import, 'ok');
            });
        };
    }

    function OpenbaseWizardDepartment($scope, swif, $http, $q, openbase) {
        var wizard = openbase.wizard;
        $scope.items = {};
        $scope.loading = {import: {}};
        $scope.contentType = 'department';
        $scope.heads = 'Nom,Technique,Demande d\'inter,Intervention,Taches';
        $scope.fields = ['name', 'technical', 'is_assignable_to_ask', 'is_assignable_to_project', 'is_assignable_to_task'];
        var fields = ['name', 'technical', 'is_assignable_to_ask', 'is_assignable_to_project', 'is_assignable_to_task'];
        wizard.load_json($scope.items, 'json/wizard_departments.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = wizard.pre_import_data($scope.items.selected, $scope.fields);
            wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

    function OpenbaseWizardPartnerCategories($scope, swif, $http, $q, openbase) {
        'ngInject';
        $scope.items = {};
        $scope.contentType = 'partner_type';
        $scope.heads = 'Nom,Code,Notifications,Demandeur,Fournisseur/Prestataire,Prestataire,Fournisseur';
        //fields of the object
        $scope.fields = ['name', 'code', 'sending_mail', 'customer', 'supplier', 'service_supplier', 'product_supplier'];
        //fields for import params
        var fields = ['name', 'code', 'sending_mail', 'customer', 'supplier', 'service_supplier', 'product_supplier'];
        openbase.wizard.load_json($scope.items, 'json/wizard_partner_categories.json');
        $scope.import_data = function () {
            swif.message.loading($scope.loading.import);
            var data = openbase.wizard.pre_import_data($scope.items.selected, $scope.fields);
            openbase.wizard.import_data($scope.contentType, fields, data)
            .then(function () {
                swif.message.loading($scope.loading.import, 'ok');
                swif.message.addInfo('data imported successfully');
            });
        };
    }

})();
